import { RECEIVE_COURSES, COURSES_ERROR } from "../actions/courses_actions";

const initial = { byId: {}, allIds: [], error: null, loaded: false };

export default function coursesReducer(state = initial, action) {
  switch (action.type) {
    case RECEIVE_COURSES: {
      const byId = {};
      const allIds = [];
      (action.courses || []).forEach((c, i) => {
        const id = c._id?.$oid || c._id || `tmp_${i}`;
        byId[id] = { ...c, _id: id };
        allIds.push(id);
      });
      return { ...state, byId, allIds, loaded: true, error: null };
    }
    case COURSES_ERROR:
      return { ...state, error: action.error, loaded: true };
    default:
      return state;
  }
}
